import { render, staticRenderFns } from "./AddNewNotification.vue?vue&type=template&id=124db5c1"
import script from "./AddNewNotification.vue?vue&type=script&lang=js"
export * from "./AddNewNotification.vue?vue&type=script&lang=js"
import style0 from "./AddNewNotification.vue?vue&type=style&index=0&id=124db5c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports